import initialStateSubscribable from '@/shared/mixins/store/subscribableData/initialState';

import { SharedActivitiesState } from './types';

export default function initialState(): SharedActivitiesState {
  return {
    ...initialStateSubscribable(),
  };
}
